// ExamHumanResourcesPage.tsx

import { useTranslation } from "react-i18next";
import { Groups, Badge, AssignmentInd } from "@mui/icons-material";
import { useTheme, alpha } from "@mui/material";
import quizApi from "@/services/quizService";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import type { BrandResolver } from "@/types/Portal.types";
import BaseExamPortalPage from "./BaseExamPortalPage";

const getHumanResourcesBrand =
  (isDark: boolean): BrandResolver =>
  (item) => {
    const name = item.quizName.toLowerCase();
    if (name.includes("mpf") || name.includes("mpfe")) {
      const accent = isDark ? "#80BFFF" : "#1d4ed8";
      return {
        icon: AssignmentInd,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    if (name.includes("shrm") || name.includes("cipd")) {
      const accent = isDark ? "#60a5fa" : "#2563eb";
      return {
        icon: Badge,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    const accent = isDark ? "#93c5fd" : "#3b82f6";
    return {
      icon: Groups,
      accentColor: accent,
      gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
    };
  };

export default function ExamHumanResourcesPage() {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <BaseExamPortalPage
      title={t("pages.examHumanResources.title")}
      subtitle={t("pages.examHumanResources.subtitle")}
      actionText={t("pages.examHumanResources.actionText")}
      themeConfig={{
        activeTabBg: theme.palette.primary.main,
        activeTabTextColor: theme.palette.primary.contrastText,
        borderColor: theme.palette.divider,
      }}
      fetchData={async () => {
        const res = await quizApi.getQuizzes({ search: "humanresources", limit: 99 });
        return res.data;
      }}
      brandResolver={getHumanResourcesBrand(isDark)}
      onItemSelect={(item) => navigate(`mock/quiz/${item.quizName}`)}
      isDisabled={true}
    />
  );
}
